import {
  CHATTY_GATEWAY_MODE,
  createChattyWebSearchHeaders,
  getChattyWebSearchUrl,
} from "@office-agents/chatty";
import {
  type CustomCommandsResult,
  getSharedCustomCommands,
  type StorageNamespace,
} from "@office-agents/core";

export function getCustomCommands(ns: StorageNamespace): CustomCommandsResult {
  const shared = getSharedCustomCommands({
    ns,
    includeImageSearch: true,
    webSearchBackend: CHATTY_GATEWAY_MODE
      ? {
          endpoint: getChattyWebSearchUrl(),
          getHeaders: createChattyWebSearchHeaders,
        }
      : undefined,
  });
  return {
    commands: [...shared.commands],
    promptSnippets: [...shared.promptSnippets],
  };
}
